export enum Bow {
    Open = 'Open',
    Close = 'Close'
}
